/** @jsxImportSource @emotion/react */
import type { Interpolation } from "@emotion/react";
import type { ThemeType } from "@packages/ui";
import type { HTMLAttributes } from "react";

import { DIFFICULTIES } from "../../lib/constants/difficulties";
import type { Game } from "../../schema";

const cssDiv: Interpolation<ThemeType> = (theme) => ({
  borderRadius: theme.radius.xs,
  height: 18,
});

export const MatrixItem = ({
  difficulty,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  difficulty: Game["state"]["summary"]["matrix"][number][number]["difficulty"];
}) => (
  <div
    css={cssDiv}
    style={{ backgroundColor: DIFFICULTIES[difficulty].color }}
    {...props}
  />
);
